window.addEventListener("load", () => {
  gsap.registerPlugin(ScrollTrigger);

  // Illuminate Banner Animation
  gsap.to("#illuminate-banner", {
    opacity: 1,
    ease: "power3.out",
    scrollTrigger: {
      trigger: "#illuminate-banner .banner-normal-image",
      start: "top 20%",
      end: "center top",
      scrub: true,
      onEnter: () =>
        gsap.to("#illuminate-banner .banner-bright-image", {
          opacity: 0.8,
          duration: 1,
          ease: "power3.out",
        }),
      onLeaveBack: () =>
        gsap.to("#illuminate-banner .banner-bright-image", {
          opacity: 0,
          duration: 1,
          ease: "power3.out",
        }),
    },
  });

  // Hilicon Chipset Section Animations
  gsap.from("#hilsicon-chipset .section-content", {
    opacity: 0,
    y: 30,
    scrollTrigger: {
      trigger: "#hilsicon-chipset .section-content",
      start: "top 70%",
      end: "top 20%",
      scrub: true,
    },
  });

  gsap.from("#hilsicon-chipset .section-text.mediumhide", {
    opacity: 0,
    y: 30,
    scrollTrigger: {
      trigger: "#hilsicon-chipset",
      start: "center 60%",
      end: "center 20%",
      scrub: true,
    },
  });

  gsap.from("#hilsicon-chipset img", {
    opacity: 0,
    y: 30,
    scrollTrigger: {
      trigger: "#hilsicon-chipset",
      start: "center 60%",
      end: "center 20%",
      scrub: true,
    },
  });

  // Animation Banner Section
  gsap.from(".animation-banner .section-content", {
    opacity: 0,
    y: 30,
    scrollTrigger: {
      trigger: ".animation-banner",
      start: "top 70%",
      end: "top 30%",
      scrub: true,
      onUpdate: () => {
        if (window.innerWidth > 750) {
          ScrollTrigger.refresh();
        }
      },
    },
  });

  // Founders View Section
  gsap.from(".founders-view .content", {
    opacity: 0,
    y: 30,
    scrollTrigger: {
      trigger: ".founders-view",
      start: "center 90%",
      end: "center 50%",
      scrub: true,
    },
  });

  // Illuminate Banner Content Animation
  gsap.from("#illuminate-banner .section-content", {
    opacity: 0,
    y: 30,
    scrollTrigger: {
      trigger: "#illuminate-banner",
      start: "top 70%",
      end: "top 20%",
      scrub: true,
    },
  });

  // Hilicon Chipset Banner Animation
  gsap.to("#hilsicon-chipset .banner-normal-image", {
    opacity: 0,
    ease: "power3.out",
    scrollTrigger: {
      trigger: "#hilsicon-chipset .banner-normal-image",
      start: "top center",
      end: "bottom top",
      scrub: true,
      onEnter: () =>
        gsap.to("#hilsicon-chipset .banner-bright-image", {
          opacity: 1,
          duration: 1,
          ease: "power3.out",
        }),
      onLeaveBack: () =>
        gsap.to("#hilsicon-chipset .banner-bright-image", {
          opacity: 0,
          duration: 1,
          ease: "power3.out",
        }),
    },
  });
});
